import angular from 'angular';

export default angular.module('supportApi', []);



// WEBPACK FOOTER //
// ./modules/supportApi/supportApi.module.js